import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "id", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuButton, MenuList, MenuItem } from 'components/Menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ActionButtonMenu(_ref) {
  var items = _ref.items,
    id = _ref.id,
    titleId = _ref.titleId,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Menu, {
    id: id,
    menuPlacement: "bottom-end",
    children: [/*#__PURE__*/_jsx(MenuButton, _objectSpread(_objectSpread({
      variant: "transparent",
      icon: "tools",
      iconOnly: true,
      "aria-labelledby": "controller-".concat(id, " ").concat(titleId)
    }, otherProps), {}, {
      children: t('actions')
    })), /*#__PURE__*/_jsx(MenuList, {
      children: items.map(function (_ref2) {
        var value = _ref2.value,
          icon = _ref2.icon,
          onSelect = _ref2.onSelect;
        return /*#__PURE__*/_jsx(MenuItem, {
          icon: icon,
          onClick: onSelect,
          children: value
        }, value);
      })
    })]
  });
}
export default ActionButtonMenu;